import {ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
  selector: 'app-cell',
  templateUrl: './cell.component.html',
  styleUrls: ['./cell.component.scss'],
  // changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CellComponent implements OnInit {

  @Input() value: string;
  @Input() nextValue: string;
  @Output() select: EventEmitter<any> = new EventEmitter<any>();

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /Users/mengxin/Develop/WebProjects/xin-angular/src/app/pages/home/mobx-tic-tac/tic-tac-toe/cell/cell.component.ts